import { SC_Input } from "../input/SC_Input";
import * as _ from 'lodash';
import { SC_Inv } from "../wr/SC_Inv";
import { RoofType } from "../roof/RoofType";
import { Sol50OnRoof } from "./Sol50OnRoof";
import { MountingType } from "./MountingType";
import { MountingSystem } from "./MountingSystem";
import { HProfile_find } from './hProfile';
import { HLine } from "../area/HLine";
import { Global } from "../utilities/global";
import { Dyn } from "../utilities/dyn";
import { SC_Beam } from '../roof/SC_Beam';
import { VLine } from '../area/VLine'; ``
import { DrawVProfile } from './vProfile';
import { HGroup } from '../area/HGroup';
import { Rectangle } from "../area/Rectangle";
import { AreaRect } from '../area/AreaRect';
import { AreaInformation } from '../area/AreaInformation';
import { RoofShape } from "../roof/RoofShape";
import { Sol50 } from "./Sol50";
import { Intersections } from './findIntersections';
import { RoofItemType } from "./roofItemType";

export function getAllInString(): RoofItemType[] {
    var iTmp: number;
    var sRes: RoofItemType[] = [];
    sRes.push(new RoofItemType(NaN, Sol50OnRoof.sHProfileVar, getHProfile()));
    if (SC_Input.bBeam) {
        sRes.push(new RoofItemType(NaN, Sol50OnRoof.sHVerbVar, getHVerb()));
        sRes.push(new RoofItemType(NaN, Sol50OnRoof.sVProfileVar, getVProfile()));
        sRes.push(new RoofItemType(NaN, Sol50OnRoof.sVVerbVar, getVVerb()));
        sRes.push(new RoofItemType(NaN, Sol50OnRoof.sVAbKapVar, getVAbKap()));
        sRes = sRes.concat(Intersections.getFastenComponents());
    }
    sRes = sRes.concat(getDrillScrewRelated());
    sRes.push(new RoofItemType(NaN, Sol50OnRoof.sVerbBolzVar, getVerbBolz()));
    sRes.push(new RoofItemType(NaN, Sol50OnRoof.sAbschBlendVar, getAbschBlend()));
    sRes.push(new RoofItemType(NaN, Sol50OnRoof.sSOLGuardVar, getSOLGuard()));
    sRes.push(new RoofItemType(NaN, Sol50OnRoof.sHAbKapVar, getHAbKap()));
    sRes.push(new RoofItemType(NaN, Sol50OnRoof.sErdbausatzVar, getErdbausatz()));
    //SEN SOL-50 Rohrmanschette für Rohr 12-90mm
    if (SC_Input.iRoofType == RoofType.TRAPEZOIDAL) {
        iTmp = SC_Inv.getStrCnt();
        if (iTmp) {
            iTmp = Math.ceil(iTmp / 10);
            sRes.push(new RoofItemType(NaN, "ROHR_MANS_12_90", iTmp));
        }
    }
    if (Sol50OnRoof.sDistAdapVar != "") {
        sRes.push(new RoofItemType(NaN, Sol50OnRoof.sDistAdapVar, getDistAdap()));
    }
    return sRes;
}

//get amount
export function getHVerb(): number {
    var i: number;
    var iResult: number = 0;
    iResult = getHProfile() - 1;
    return iResult;
}

export function getHProfile(): number {
    var i: number;
    var nTotLen: number;
    var iResult: number;
    var hprofilTmp: HLine;
    MountingSystem.setVariables();
    HProfile_find();
    nTotLen = 0;
    for (i = 0; i < Global.aHProfile.length; i++) {
        hprofilTmp = Global.aHProfile[i];
        nTotLen += hprofilTmp.r - hprofilTmp.l;

    }
    nTotLen += nTotLen * Dyn.HP_PR_CO_FA;
    Sol50OnRoof.nHProfileTotLen = nTotLen;
    iResult = Math.ceil(nTotLen / Sol50OnRoof.nHProfileLen);
    return iResult;
}

//get amount
export function getVProfile(): number {
    var i: number;
    var nSum: number;
    var iResult: number;
    var vprofilTmp: VLine;
    if (SC_Input.iBeamType == SC_Beam.PURLIN) {
        DrawVProfile.Purlin_VProfile_find();
    } else {
        DrawVProfile.VProfile_find();
    }
    nSum = 0;
    for (i = 0; i < Sol50OnRoof.aVProfile.length; i++) {
        vprofilTmp = Sol50OnRoof.aVProfile[i];
        nSum += vprofilTmp.b - vprofilTmp.t;
    }
    iResult = Math.ceil(nSum / Sol50OnRoof.nHProfileLen);
    return iResult;
}

export function getVVerb(): number {
    var i: number;
    var iResult: number = 0;
    iResult = getVProfile() - 1;
    return iResult;
}

export function getVAbKap(): number {
    var iResult: number = 0;
    var hgroupTmp: HGroup;
    var vlineTmp: VLine;
    var i: number;
    var j: number;
    var bHasPanelBelow: boolean;
    for (i = 0; i < Sol50OnRoof.aVProfile.length; i++) {
        vlineTmp = new VLine(Sol50OnRoof.aVProfile[i]);
        bHasPanelBelow = false;
        for (j = 0; j < Global.hgroups.length; j++) {
            hgroupTmp = new HGroup(Global.hgroups[j]);
            //y
            if (hgroupTmp.y + hgroupTmp.height < vlineTmp.b) {
                continue;
            }
            //x
            if ((hgroupTmp.x > vlineTmp.x) || (hgroupTmp.x + hgroupTmp.width < vlineTmp.x)) {
                continue;
            }
            var nDist: number;
            nDist = Math.abs(hgroupTmp.y - vlineTmp.b);
            if (nDist < 20) {
                bHasPanelBelow = true;
                break;
            }
        }
        if (!bHasPanelBelow) {
            iResult++;
        }
    }
    iResult = Math.ceil(iResult / Sol50OnRoof.nVAbKapVPE);
    return iResult;
}

export function getDrillScrewRelated(): RoofItemType[] {
    var result: RoofItemType[] = [];
    // Initialize total amount
    Sol50OnRoof.iDrillScrewTotal = 0;
    result = result.concat(getKabFanNetString());
    if (SC_Input.iMountingType == MountingType.DIRECT) {
        result = result.concat(getCorrosionProtectionString());
    }
    result = result.concat(getDrillScrewString());
    return result;
}

export function getDrillScrewString(): RoofItemType[] {
    var result: RoofItemType[] = [];
    Sol50OnRoof.iDrillScrewTotal += getDrillScrewCount();
    if (Sol50OnRoof.iDrillScrewTotal > 0) {
        result.push(new RoofItemType(NaN, Sol50OnRoof.sDrillScrewVar, Math.ceil(Sol50OnRoof.iDrillScrewTotal / Sol50OnRoof.nDrillScrewVPE)));
    }
    return result;
}
//get amount
export function getDrillScrewCount(): number {
    var iResult: number = 0;
    var nFactor: number;
    var aIntersections: any[];
    if (Sol50OnRoof.sDrillScrewVar == "") {
        return 0;
    }
    if (SC_Input.iRoofType == RoofType.PANTILED) {
        nFactor = 4;
        iResult = (Sol50OnRoof.iRoofHookBigCount + Sol50OnRoof.iRoofHookSmallCount) * nFactor;
        iResult += getVVerb() * 2;
        iResult += getHVerb() * 2;
    } else if (SC_Input.iRoofType == RoofType.CORRUGATED) {
        nFactor = 2;
        aIntersections = Intersections.findIntersections();
        iResult = aIntersections.length * nFactor;
        iResult += getVVerb() * 2;
        iResult += getHVerb() * 2;
        iResult += getStoSch() * nFactor;
    } else if (SC_Input.iRoofType == RoofType.TRAPEZOIDAL) {
        if (SC_Input.iMountingType == MountingType.CRISS_CROSS) {
            nFactor = 2;
            aIntersections = Intersections.findIntersections();
            iResult = aIntersections.length * nFactor;
            iResult += getVVerb() * 2;
            iResult += getHVerb() * 2;
            iResult += getStoSch() * nFactor;
        } else if (SC_Input.iMountingType == MountingType.DIRECT) {
            // See corrosion protection's calculation
            iResult = 0;
        }
    } else if (SC_Input.iRoofType == RoofType.SLATED) {
        nFactor = 2;
        aIntersections = Intersections.findIntersections();
        //intersections
        iResult = aIntersections.length * nFactor;
        //vertical connector
        iResult += getVVerb() * 2;
        //horizontal connector
        iResult += getHVerb() * 2;
        //screws
        iResult += aIntersections.length * 2;
    } else if (SC_Input.iRoofType == RoofType.PLAIN_TILED) {
        nFactor = 4;
        iResult = (Sol50OnRoof.iRoofHookBigCount + Sol50OnRoof.iRoofHookSmallCount) * nFactor;
        iResult += getVVerb() * 2;
        iResult += getHVerb() * 2;
    }
    return iResult;
}

export function getStoSch(): number {
    var iLen: number;
    Intersections.StoSch_find();
    iLen = Sol50OnRoof.aStoSch.length;
    return iLen;
}

//get parameter string
export function getKabFanNetString(): RoofItemType[] {
    var result: RoofItemType[] = [];
    var iKabFanNetCnt: number;
    iKabFanNetCnt = getKabFanNetCount();
    if (iKabFanNetCnt > 0) {
        result.push(new RoofItemType(NaN, Sol50OnRoof.sKabFanNetVar, iKabFanNetCnt));
    }
    Sol50OnRoof.iDrillScrewTotal += iKabFanNetCnt * 20;
    return result;
}

export function getKabFanNetCount(): number {
    var i: number;
    var hgroupTmp: HGroup;
    var result: number = 0;
    var nSum: number;
    if (Sol50OnRoof.sKabFanNetVar == "") {
        return 0;
    }
    nSum = 0;
    for (i = 0; i < Global.hgroups.length; i++) {
        hgroupTmp = new HGroup(Global.hgroups[i]);
        nSum += hgroupTmp.width;
    }
    result = Math.ceil(nSum / 1400);
    return result;
}

export function getCorrosionProtectionString(): RoofItemType[] {
    var result: RoofItemType[] = [];
    var optimal_distance: number;
    var i: number;
    var profile_line: HLine;
    var profile_line_len: number;
    var drill_screw_count: number;
    var corrosion_protection_count: number;
    if (SC_Input.iMountingType != MountingType.DIRECT) {
        return [];
    }
    if (SC_Input.nHighBeadingDistance <= 22.5) {
        optimal_distance = SC_Input.nHighBeadingDistance * 2;
    } else {
        optimal_distance = SC_Input.nHighBeadingDistance;
    }
    drill_screw_count = 0;
    corrosion_protection_count = 0;
    for (i = 0; i < Global.aHProfile.length; i++) {
        profile_line = new HLine(Global.aHProfile[i]);
        profile_line_len = profile_line.r - profile_line.l;
        drill_screw_count += Math.ceil((profile_line_len / (optimal_distance) + 1) * 2);
        corrosion_protection_count += Math.ceil(profile_line_len / (SC_Input.nHighBeadingDistance) + 1);
    }
    result.push(new RoofItemType(NaN, Sol50OnRoof.sCorrosionProtectionVar, Math.ceil(corrosion_protection_count / Sol50OnRoof.nCorrosionProtectionVPE)));
    Sol50OnRoof.iDrillScrewTotal += drill_screw_count;
    return result;
}

//get amount
export function getVerbBolz(): number {
    var iResult: number = 0;
    if (SC_Input.iMountingType == MountingType.DIRECT) {
        iResult = Math.ceil(((getHProfile() - 1) * 2) / 50);
    }
    return iResult;
}

////get amount
export function getAbschBlend(): number {
    var i: number;
    var hprofilTmp: HLine;
    var iResult: number = 0;
    var nDif: number;
    var nSum: number;
    nSum = 0;
    for (i = 0; i < Global.aHProfile.length; i++) {
        hprofilTmp = new HLine(Global.aHProfile[i]);
        nDif = (hprofilTmp.r - hprofilTmp.l) - hprofilTmp.e;
        nSum += nDif;
    }
    nSum += nSum * Dyn.HP_PR_CO_FA;
    iResult = Math.ceil(nSum / Sol50OnRoof.nAbschBlendLen);
    return iResult;
}
//get amount
export function getSOLGuard(): number {
    var i: number;
    var hgroupTmp: HGroup;
    var iResult: number = 0;
    for (i = 0; i < Global.hgroups.length; i++) {
        hgroupTmp = new HGroup(Global.hgroups[i]);
        iResult += (hgroupTmp.iCnt + 1);
    }
    return iResult;
}

//get amount
export function getHAbKap(): number {
    var iResult: number = 0;
    iResult = Math.ceil((Global.aHProfile.length * 2) / 10);
    return iResult;
}

//
//get amount
export function getErdbausatz(): number {
    return Area_determine().length;
}

//get amount
export function getDistAdap(): number {
    var i: number;
    var hgroupTmp: HGroup;
    var iResult: number = 0;
    for (i = 0; i < Global.hgroups.length; i++) {
        hgroupTmp = new HGroup(Global.hgroups[i]);
        if (hgroupTmp.nModWith > hgroupTmp.height) {
            iResult += (hgroupTmp.iCnt * 4) + 2;
        } else {
            iResult += (hgroupTmp.iCnt * 2) + 2;
        }
    }
    iResult = Math.ceil(iResult / Sol50OnRoof.nDistAdapVPE);
    return iResult;
}

export function Area_findNextRow(aAreaRects: any[], arearectTmp1: AreaRect, iStart: number, iLen: number): void {
    var nTop1: number, nBottom1: number;
    var nLeft1: number, nRight1: number;
    var nTop2: number, nBottom2: number;
    var nLeft2: number, nRight2: number;
    var arearectTmp2: AreaRect;
    var nYDif: number;
    var nVDist: number;
    var nHDist: number;
    var j: number;
    nTop1 = arearectTmp1.y;
    nBottom1 = arearectTmp1.y + arearectTmp1.height;
    nLeft1 = arearectTmp1.x;
    nRight1 = arearectTmp1.x + arearectTmp1.width;
    nVDist = Sol50.nVertikalAbstand + Global.nModAbstTol;
    nHDist = Sol50.nHorizontalAbstand + Global.nModAbstTol;
    for (; iStart < iLen; iStart++) {
        arearectTmp2 = aAreaRects[iStart];
        nTop2 = arearectTmp2.y;
        nBottom2 = arearectTmp2.y + arearectTmp2.height;
        nLeft2 = arearectTmp2.x;
        nRight2 = arearectTmp2.x + arearectTmp2.width;
        nYDif = nTop2 - nBottom1;
        if (nYDif > nVDist) {
            break;
        } else if (nYDif > 0) {
            if (nLeft2 < nRight1 + nHDist && nRight2 + nHDist > nLeft1) {
                if (arearectTmp2.aGroup != null) {
                    if (arearectTmp1.aGroup != arearectTmp2.aGroup) {
                        //swap
                        Area_swapGroup(arearectTmp1.aGroup, arearectTmp2.aGroup);
                    }
                    continue;
                } else {
                    arearectTmp1.aGroup.push(arearectTmp2);
                    arearectTmp2.aGroup = arearectTmp1.aGroup;
                }
                j = iStart + 1;
                if (j < iLen) {
                    Area_findNextRow(aAreaRects, arearectTmp2, j, iLen);
                }
            }
        }
    }
}

export function Area_determine(): any[] {
    var hgroupTmp: HGroup;
    var i: number, j: number;
    var iLen: number;
    var aAreaRects: any[];
    var arearectTmp: AreaRect;
    var aGroup: any[];
    var aGroupList: any[];
    iLen = Global.hgroups.length;
    aGroupList = new Array();
    if (iLen == 0) return aGroupList;
    //copy
    aAreaRects = new Array();
    for (i = 0; i < iLen; i++) {
        hgroupTmp = new HGroup(Global.hgroups[i]);
        arearectTmp = new AreaRect();
        arearectTmp.x = hgroupTmp.x;
        arearectTmp.y = hgroupTmp.y;
        arearectTmp.width = hgroupTmp.width;
        arearectTmp.height = hgroupTmp.height;
        aAreaRects.push(arearectTmp);
    }
    //sort by y
    aAreaRects = _.sortBy(aAreaRects, 'y');
    for (i = 0; i < iLen; i++) {
        arearectTmp = aAreaRects[i];
        if (arearectTmp.aGroup != null) {
            continue;
        }
        aGroup = new Array();
        aGroup.push(arearectTmp);
        arearectTmp.aGroup = aGroup;
        j = i + 1;
        if (j < iLen) {
            Area_findNextRow(aAreaRects, arearectTmp, j, iLen);
        }
        if (aGroup.length > 0) {
            aGroupList.push(aGroup);
        }
    }
    return aGroupList;
}

export function getCountAreaDetermine() {
    Area_determine();
}

export function Area_collectInformation(aGroupList: any[]): any[] {
    var rect: Rectangle;
    var sRange: string;
    var i: number;
    var j: number;
    var aGroupTmp: any[];
    var areaHLine: AreaRect;
    var aAreaInfo: any[];
    var ret: AreaInformation;
    var info: AreaInformation;
    var nLeft: number;
    var nRight: number;
    // aGroupList = Sol50OnRoof.Area_determine();
    //rectangle buffer
    rect = new Rectangle();
    aAreaInfo = new Array();
    for (i = 0; i < aGroupList.length; i++) {
        nLeft = Number.MAX_VALUE;
        nRight = Number.MIN_VALUE;
        aGroupTmp = aGroupList[i];
        info = new AreaInformation();
        info.sRange = "h";
        info.hasPortrait = false;
        for (j = 0; j < aGroupTmp.length; j++) {
            areaHLine = <AreaRect>aGroupTmp[j];
            rect.left = areaHLine.x;
            rect.top = areaHLine.y;
            rect.height = areaHLine.height;
            rect.width = areaHLine.width;
            sRange = RoofShape.getRangeByRect(rect);
            if (nLeft > areaHLine.x) {
                nLeft = areaHLine.x;
            }
            if (nRight < areaHLine.x + areaHLine.width) {
                nRight = areaHLine.x + areaHLine.width;
            }
            if (info.sRange.charCodeAt(0) > sRange.charCodeAt(0)) {
                info.sRange = sRange;
            }
            //check for portrait panel alignment
            if (areaHLine.height > SC_Input.nModWidth) {
                info.hasPortrait = true;
            }
        }
        info.left = nLeft;
        info.right = nRight;
        aAreaInfo.push(info);
    }
    return aAreaInfo;
}

export function Area_swapGroup(aGroupSrc: any[], aGroupDst: any[]): void {
    aGroupSrc.forEach((arearectTmp) => {
        arearectTmp.aGroup = aGroupDst;
        aGroupDst.push(arearectTmp);
    });
    // for each(var arearectTmp: AreaRect in aGroupSrc) {

    // }
    aGroupSrc.splice(0);
}
